/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { MarkupDialogComponent } from './dialog/markup-dialog.component';
import { MarkupBottomSheetComponent } from './bottom-sheet/markup-bottom-sheet.component';
import { MediaObserver } from '@angular/flex-layout';
import { OverlayPositionBuilder } from '@angular/cdk/overlay';
import { Dialog } from '@angular/cdk/dialog';
import { take } from 'rxjs/operators';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

export class MarkupCommand extends MapCommand {

    private dialog: Dialog;
    private position: OverlayPositionBuilder;
    private bottomSheet: MatBottomSheet;
    private media: MediaObserver;

    invoke() {
        if (this.media.isActive('lt-md')) {
            this.showMarkupBottomSheet();
        } else {
            this.showMarkupPanel();
        }
    }

    protected onCommandInit() {
        super.onCommandInit();
        this.dialog = this.deps['dialog'];
        this.position = this.deps['position'];
        this.bottomSheet = this.deps['bottomSheet'];
        this.media = this.deps['media'];
    }

    private showMarkupPanel() {
        this.dialog.open(MarkupDialogComponent, {
            hasBackdrop: false,
            panelClass: 'dash-gis-floating-panel',
            positionStrategy: this.position
                .global().right('120px').top('200px')
        }).closed.pipe(
            take(1),
        ).subscribe(() => this.deactivate$.next());
    }

    private showMarkupBottomSheet() {
        this.bottomSheet.open(MarkupBottomSheetComponent, {
            disableClose: true,
            hasBackdrop: false
        }).afterDismissed().pipe(
            take(1)
        ).subscribe(() => this.deactivate$.next());
    }
}
